module.exports = __webpack_public_path__ + "img/pop.0832ee60.png";